import { Component, Input } from "@angular/core";

// might need something like this in the future
export interface CustomFlowComponent {
	flowName: string;
}

@Component({
  template: `
    <div>CUSTOM FLOW GOES HERE</div>
`,
  styles: []
})
export class FirstCheckCustomFlowComponent implements CustomFlowComponent
{
  public readonly flowName : string = "first-check-v1";

  constructor ()
  {
    /* Nothing. */
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/intake-form/custom-flows/first-check-v1-flow.component.ts